// extracted by mini-css-extract-plugin
export default {"loading":"PageLoading_loading__uOH3n","loadingShrink":"PageLoading_loadingShrink__ocg7v"};